import { createContext, useContext, useState } from 'react';
import type { LoanDetailsData, LoanDocumentsData, LoanIdentityData } from '../ui/steps/types';

interface LoanApplicationState {
  businessKey: string | null;
  details: LoanDetailsData | null;
  identity: LoanIdentityData | null;
  documents: LoanDocumentsData | null;
}

interface LoanApplicationContextValue extends LoanApplicationState {
  setBusinessKey: (key: string) => void;
  setDetails: (data: LoanDetailsData) => void;
  setIdentity: (data: LoanIdentityData) => void;
  setDocuments: (data: LoanDocumentsData) => void;
}

const LoanApplicationContext = createContext<LoanApplicationContextValue | null>(null);

export const LoanApplicationProvider = ({ children }: { children: React.ReactNode }) => {
  const [businessKey, setBusinessKey] = useState<string | null>(null);
  const [details, setDetails] = useState<LoanDetailsData | null>(null);
  const [identity, setIdentity] = useState<LoanIdentityData | null>(null);
  const [documents, setDocuments] = useState<LoanDocumentsData | null>(null);

  return (
    <LoanApplicationContext.Provider
      value={{
        businessKey,
        details,
        identity,
        documents,
        setBusinessKey,
        setDetails,
        setIdentity,
        setDocuments,
      }}
    >
      {children}
    </LoanApplicationContext.Provider>
  );
};

export const useLoanApplication = (): LoanApplicationContextValue => {
  const ctx = useContext(LoanApplicationContext);
  if (!ctx) throw new Error('useLoanApplication must be used inside LoanApplicationProvider');

  return ctx;
};
